// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d85cfadc","239":"2f822dd7","455":"613fd633","488":"ce69ba5f","661":"a311df8b","707":"f1b56019","945":"6e4284d3","979":"c46b748b"}[chunkId] + ".chunk.js";
};